
import React from 'react';

interface IProps {
  style?: any;
}

export const RectangleIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="207" height="102" viewBox="0 0 207 102" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
    <rect width="207" height="102" fill="#dee2eb"/>
    </svg>

  )
}
